import loanFormModel, {
  taxDocuments,
} from '../../components/loan_application/form_models/loanFormModel';
import { defaultApplicantName } from '../../constants';
import { ValidationSchema } from '../interfaces';
import FileNameValidationSchema from '../FileNameValidationSchema';
import { Validation } from '../Validation';

const { financialStatementQ3 } = taxDocuments;

const { systemPowerUsage, isPG } = loanFormModel.formField;

export class FinancialStatementQ3Validation implements ValidationSchema {
  public name = financialStatementQ3.name;
  public label = financialStatementQ3.getLabel(defaultApplicantName);
  public dependsOn: string[] = [isPG.name, systemPowerUsage.name];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public when(isPersonalGuarantor, systemPowerUsage, schema) {
    const required =
      financialStatementQ3.displayCondition(isPersonalGuarantor) &&
      financialStatementQ3.getRequired(systemPowerUsage);
    return FileNameValidationSchema(financialStatementQ3.name, required);
  }
}
export default new Validation(new FinancialStatementQ3Validation());
